import QRCodeDetail from "./pages/FormPage.vue";
import QRCodeIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/qr",
    component: QRCodeIndex,
    redirect: "/qr/list",
    name: "qr",
    children: [
      {
        path: "create",
        component: QRCodeDetail,
        name: "qr.create",
      },
    ],
  },
];
